import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, of, shareReplay } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { content } from '../../../../assets/content/fallback-content';

@Injectable({
  providedIn: 'root',
})
export class ContentService {
  private readonly httpClient = inject(HttpClient);

  private content: Observable<any> | null = null;

  getContent(): Observable<any> {
    const contentEndpointURL = environment.AEM_CAAS_ENDPOINT;
    this.content ??= this.httpClient.get<any>(contentEndpointURL).pipe(
      catchError((error) => {
        console.error(error);
        return of(content);
      }),
      shareReplay(1),
    );
    return this.content;
  }
}
